import {TManualPropertyRecord} from "../components/manual-property-form/ManualPropertyForm";

export type TFormError = {
    field: string,
    message: string,
}

export default class ManualPropertyValidator {
    validate(manualProperty: TManualPropertyRecord, validateSystemName = false): TFormError[] {
        const errors: TFormError[] = [];

        if (!this.assertStringPresence(manualProperty.name)) {
            errors.push({
                field: "name",
                message: "Name cannot be blank",
            });
        }

        if (validateSystemName && !this.assertStringPresence(manualProperty.systemName)) {
            errors.push({
                field: "systemName",
                message: "Name cannot be blank",
            });
        }

        if (manualProperty.reforecastStartMonthIndex < 0 || manualProperty.reforecastStartMonthIndex > 11) {
            errors.push({
                field: "reforecastStartMonthIndex",
                message: "Valid month is required",
            });
        }

        return errors;
    }

    private assertStringPresence(value: string | undefined): boolean {
        return !!value && value.trim() !== "";
    }
}